export default "__VITE_ASSET__DmL46esC__";